<template>
  <div v-show="showFilter" class="filter-wrapper">
    <div class="col-xs-12 p-0 p-relative filter-options">
      <div class="col-xs-12 p-0 mt-5 fw-600 font-14 mb-30 emergo-brand-black">{{ $t('appliedFilters') }}</div>
      <section>
        <div class="col-xs-12 pr-0 pl-8">
          <div
            class="col-xs-12 p-0"
            v-for="value in filtersList"
            :key="value"
            :class="{
              'mb-30':
                !((value === 'columnOptions' && permissions.indexOf('COLUMN_OPTIONS') === -1) ||
                (value === 'countryOfOrigin' && permissions.indexOf('COUNTRY_WISE_FILTER_AND_SEARCH') === -1) ||
                (value === 'expirationDate' && permissions.indexOf('EXPIRATION_DATES') === -1))
            }"
          >
            <div
              class="col-xs-12 col-md-12 col-lg-12 p-0 cursor-pointer"
              :class="{
                'hide-field':
                  (value === 'columnOptions' && permissions.indexOf('COLUMN_OPTIONS') === -1) ||
                  (value === 'countryOfOrigin' && permissions.indexOf('COUNTRY_WISE_FILTER_AND_SEARCH') === -1) ||
                  (value === 'expirationDate' && permissions.indexOf('EXPIRATION_DATES') === -1)
              }"
            >
              <div class="col-xs-12 p-0 d-flex col-gap-10" @click="toggleSelection(`collapse${value}`, value)">
                <img
                  v-if="!selection[value]"
                  src="/static/images/icons/emergo_chevron_down.svg"
                  class="transform-img"
                />
                <img v-else src="/static/images/icons/emergo_chevron_down.svg" />
                <a
                  class="font-properties fw-600 font-14 filter-name"
                  data-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  :aria-controls="`collapse${value}`"
                  >{{ $t(value) }}</a
                >
              </div>
            </div>
            <div
              v-if="`collapse${value}` === 'collapsecolumnOptions'"
              class="col-xs-12 col-md-12 col-lg-12 collapse pl-14 pr-0 item-divider list-options"
              :class="[selection[value] ? 'in' : '', `collapse${value}`]"
            >
              <ul role="menu" v-on:click.stop class="options-ul">
                <li class="col-xs-12 mb-0 pl-14 pr-0" v-for="cellVal in availableColumns" :key="`country${cellVal}`">
                  <div class="col-xs-12 p-0 d-flex align-items-center col-gap-10 mb-16">
                    <div>
                      <div class="checkbox-wrapper">
                        <label class="custom-checkbox">
                          <input :value="cellVal" v-model="userSelectableColumns" type="checkbox" />
                          <span class="select-check"></span>
                        </label>
                      </div>
                    </div>

                    <div class="column-options-items-text font-14 emergo-neutrals-gray">
                      <span class="vertical-align-sub select-item">{{ translate(cellVal) }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              v-if="`collapse${value}` === 'collapsecountryOfOrigin'"
              class="col-xs-12 col-md-12 col-lg-12 collapse pl-14 pr-0 list-options"
              :class="[selection[value] ? 'in' : '', `collapse${value}`]"
            >
              <div class="col-xs-12 p-0 emergo-filter-search-container mb-20">
                <input
                  type="text"
                  :placeholder="$t('search')"
                  class="emergo-filter-search search-input-field"
                  v-model="countryName"
                  @keyup.enter="filterCountriesList"
                />
                <img
                  @click="filterCountriesList"
                  class="emergo-filter-search-icon cursor-pointer"
                  src="/static/images/icons/emergo_filter_search.svg"
                />
              </div>
              <div class="col-xs-12 pr-0 pl-14">
                <el-scrollbar wrap-style="height: 400px;">
                  <ul role="menu" v-on:click.stop class="options-ul">
                    <li
                      class="col-xs-12 mb-0 p-0"
                      v-for="country in availableCountriesList"
                      :key="`country${country.id}`"
                    >
                      <div class="col-xs-12 p-0 d-flex align-items-center col-gap-10 mb-16">
                        <div>
                          <div class="checkbox-wrapper">
                            <label class="custom-checkbox">
                              <input
                                :value="country.id"
                                v-model="selectedCountryIdList"
                                @change="setFilteredCountriesList"
                                type="checkbox"
                              />
                              <span class="select-check"></span>
                            </label>
                          </div>
                        </div>

                        <div class="column-options-items-text font-14 emergo-neutrals-gray">
                          <span class="vertical-align-sub select-item">{{ country.name }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-scrollbar>
              </div>
            </div>
            <div
              v-if="`collapse${value}` === 'collapseexpirationDate'"
              class="col-xs-12 col-md-12 col-lg-12 collapse pl-32 pr-0 item-divider list-options"
              :class="[selection[value] ? 'in' : '', `collapse${value}`]"
            >
              <ul class="pl-0">
                <li
                  class="col-xs-12 p-0 d-flex cursor-pointer"
                  @click="onDocumentDaysSelection('isThisMonth', 'expirationDates')"
                >
                  <div
                    class="col-xs-10 pl-0 sub-approval mb-16 font-14 emergo-neutrals-gray"
                    :class="{ 'font-bold': totalDates.expirationDates.isThisMonth }"
                  >
                    {{ $t('thisMonth') }}
                  </div>
                  <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isThisMonth">
                    <img src="/static/images/icons/check.svg" class="image-size" />
                  </a>
                </li>
                <li
                  class="col-xs-12 p-0 d-flex cursor-pointer"
                  @click="onDocumentDaysSelection('isNext3Months', 'expirationDates')"
                >
                  <div
                    class="col-xs-10 pl-0 sub-approval mb-16 font-14 emergo-neutrals-gray"
                    :class="{ 'font-bold': totalDates.expirationDates.isNext3Months }"
                  >
                    {{ $t('next3Months') }}
                  </div>
                  <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isNext3Months">
                    <img src="/static/images/icons/check.svg" class="image-size" />
                  </a>
                </li>
                <li
                  class="col-xs-12 p-0 d-flex cursor-pointer"
                  @click="onDocumentDaysSelection('isThisYear', 'expirationDates')"
                >
                  <div
                    class="col-xs-10 pl-0 sub-approval mb-16 font-14 emergo-neutrals-gray"
                    :class="{ 'font-bold': totalDates.expirationDates.isThisYear }"
                  >
                    {{ $t('withInThisYear') }}
                  </div>
                  <a class="col-xs-2 p-0 text-right" v-if="totalDates.expirationDates.isThisYear">
                    <img src="/static/images/icons/check.svg" class="image-size" />
                  </a>
                </li>
              </ul>
              <div class="col-xs-12 p-0">
                <div class="col-xs-12 p-0 mb-16 font-14 emergo-neutrals-gray">{{ $t('dateRange') }}</div>

                <div class="col-xs-12 pl-8 pr-0">
                  <filter-date
                    :eventType="'expirationDates'"
                    @dateRange="setCustomDateRange($event, 'expirationDates', 'expirationDates')"
                    :label="types.label"
                    :dateFormat="dateFormat"
                  >
                  </filter-date>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="col-xs-12 p-0 d-flex justify-content-between footer-section">
        <button class="btn emergo-btn emergo-secondary-button" @click="setFilter">
          {{ $t('clearLabel') }}
        </button>
        <button
          :disabled="!isFiltersApplied"
          @click="applySelectedFilters"
          class="btn emergo-btn emergo-primary-button"
        >
          {{ $t('apply') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { cloneDeep, isEqual } from 'lodash';
import EventBus from '../../utils/event-bus';
import FilterDate from './FilterDate.vue';
import getDateRange from './mixins/dateRangeSelectionMixin';

export default {
  mixins: [getDateRange],
  props: {
    permissions: {
      type: Array,
      default: () => []
    },
    dateFormat: {
      type: String
    },
    types: {
      type: Object,
      default: () => ({})
    },
    expectedFilter: {
      type: Object,
      required: true
    },
    countriesList: {
      type: Array,
      default: () => []
    },
    selectedColumns: {
      type: Array,
      default: () => []
    },
    availableColumns: {
      type: Array,
      required: false,
      default: () => []
    },
    showFilter: {
      type: Boolean,
      default: false,
      required: true
    },
    filtersList: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  components: {
    FilterDate
  },
  data() {
    return {
      isDateEntered: false,
      totalDates: {
        expirationDates: {
          isThisMonth: false,
          isNext3Months: false,
          isThisYear: false
        }
      },
      countryName: '',
      selection: {},
      filterOptions: {},
      availableCountriesList: [],
      userSelectableColumns: [],
      selectedCountryIdList: []
    };
  },
  watch: {
    showFilter() {
      if (this.showFilter) {
        this.selection = {};
      }
    },
    countriesList: {
      handler(newValue) {
        if (newValue) {
          this.availableCountriesList = cloneDeep(this.countriesList);
        }
      },
      immediate: true
    },
    expectedFilter: {
      handler(newValue) {
        this.filterOptions = cloneDeep(newValue);
      },
      immediate: true
    },
    selectedColumns: {
      handler() {
        if (this.selectedColumns.length) {
          this.userSelectableColumns = [...this.selectedColumns];
        }
      },
      immediate: true
    },
    userSelectableColumns: {
      handler(newVal, oldValue) {
        if (this.userSelectableColumns.length) {
          if (this.userSelectableColumns.length > 6) {
            this.$nextTick(() => {
              this.userSelectableColumns.splice(6, this.userSelectableColumns.length);
            });
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Limite' : 'Limit',
              text:
                this.$i18n.locale === 'Portuguese'
                  ? 'Podem ser adicionadas no máximo 6 colunas.'
                  : 'Max 6 columns can be added.',
              group: 'custom-notification'
            });
          }
          if (this.userSelectableColumns.length < 3) {
            const text =
              this.$i18n.locale === 'Portuguese'
                ? 'A tabela deve ter no mínimo 3 colunas.'
                : 'Table should have Min 3 columns.';
            this.$nextTick(() => {
              this.userSelectableColumns = [...oldValue];
            });
            this.clearNotifcations();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Limite' : 'Limit',
              text,
              group: 'custom-notification'
            });
          }
          // this.$emit('setSelectedColumns', this.userSelectableColumns);
        }
      },
      immediate: true
    }
  },
  computed: {
    isFiltersApplied() {
      return (
        !isEqual(this.expectedFilter, this.filterOptions) || !isEqual(this.selectedColumns, this.userSelectableColumns)
      );
    }
  },
  methods: {
    applySelectedFilters() {
      if (!isEqual(this.selectedColumns, this.userSelectableColumns)) {
        this.$emit('setSelectedColumns', this.userSelectableColumns);
      }
      this.emitFilterOptions();
      this.$emit('setShowFilter');
    },
    onDocumentDaysSelection(daysSelected, dateCategory) {
      this.setDaysSelected(daysSelected, dateCategory);
      const filterKey = dateCategory === 'commonDates' ? 'dateRange' : dateCategory;
      if (this.totalDates[dateCategory][daysSelected]) {
        EventBus.$emit(`normalDatesSelected${dateCategory}`);
        this.getStartTimeAndEndTime(daysSelected, filterKey);
      } else {
        this.clearDateRangeInFilter(filterKey);
      }
    },
    getStartTimeAndEndTime(daysSelected, dateKey) {
      const { startDate, endDate } = this.getDateRange(daysSelected, this.dateFormat, this.types.label);
      this.filterOptions = { ...this.filterOptions, [dateKey]: { from: startDate, to: endDate } };
    },
    clearDateRangeInFilter(field) {
      this.filterOptions = { ...this.filterOptions, [field]: {} };
    },
    setCustomDateRange(value, key) {
      if (value.from !== '' && value.to !== '') {
        this.isDateEntered = true;
      }
      this.filterOptions = { ...this.filterOptions, [key]: value };
      this.setDaysSelected('', key);
    },
    setDaysSelected(daysSelected = '', dateCategory) {
      Object.keys(this.totalDates[dateCategory]).forEach((key) => {
        if (daysSelected) {
          this.totalDates[dateCategory][key] = key === daysSelected ? !this.totalDates[dateCategory][key] : false;
        } else this.totalDates[dateCategory][key] = false;
      });
    },
    filterCountriesList() {
      const searchWord = this.countryName.toLowerCase();
      this.availableCountriesList = this.countriesList.filter((country) =>
        country.name.toLowerCase().includes(searchWord));
    },
    setFilter() {
      if (!isEqual(this.selectedColumns, this.userSelectableColumns)) {
        this.userSelectableColumns = [...this.selectedColumns];
        this.$emit('setSelectedColumns', this.userSelectableColumns);
      }
      this.availableCountriesList = cloneDeep(this.countriesList);
      EventBus.$emit('clearAllCustomDates');
      this.countryName = '';
      this.setDefaultValuesToAllDates();
      this.selectedCountryIdList = [];
      this.$emit('setShowFilter');
      this.filterOptions = cloneDeep(this.expectedFilter);
      this.emitFilterOptions();
    },

    setDefaultValuesToAllDates() {
      this.totalDates = {
        expirationDates: {
          isThisMonth: false,
          isNext3Months: false,
          isThisYear: false
        }
      };
    },
    setFilteredCountriesList() {
      this.filterOptions.countriesList = cloneDeep(this.selectedCountryIdList);
    },
    emitFilterOptions() {
      this.$emit('setFilter', this.filterOptions);
    },
    toggleSelection(filterCSS, flag) {
      this.selection = { ...this.selection, [flag]: !this.selection[flag] };
      if ($(`.${filterCSS}`).hasClass('in')) {
        $(`.${filterCSS}`).removeClass('in');
      } else {
        $(`.${filterCSS}`).addClass('in');
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },
    convertToStrings(name) {
      switch (name) {
        case 'Accredited by':
          name = 'Accredited_by';
          break;
        case 'Approval date':
          name = 'Approval_date';
          break;
        case 'Archive reason':
          name = 'Archive_reason';
          break;
        case 'Barcode Attachments':
          name = 'Barcode_Attachments';
          break;
        case 'Brand name':
          name = 'Brand_name';
          break;
        case 'Certification URL':
          name = 'Certification_URL';
          break;
        case 'Certification mark':
          name = 'Certification_mark';
          break;
        case 'Certification number':
          name = 'Certification_number';
          break;
        case 'Comments':
          name = 'Comments';
          break;
        case 'Country of origin':
          name = 'Country_of_origin';
          break;
        case 'Description':
          name = 'Description';
          break;
        case 'Expiration':
          name = 'Expiration';
          break;
        case 'Imported Product':
          name = 'Imported_Product';
          break;
        case 'Importer':
          name = 'Importer';
          break;
        case 'Input Status':
          name = 'Input_Status';
          break;
        case 'Managed by':
          name = 'Managed_by';
          break;
        case 'Manufacturer':
          name = 'Manufacturer';
          break;
        case 'Marked input voltage':
          name = 'Marked_input_voltage';
          break;
        case 'Marked input wattage':
          name = 'Marked_input_wattage';
          break;
        case 'Model name':
          name = 'Model_name';
          break;
        case 'Ordinance':
          name = 'Ordinance';
          break;
        case 'Barcode':
          name = 'Barcode';
          break;
        case 'Product Certificate Attachments':
          name = 'Product_Certificate_Attachments';
          break;
        case 'Product category':
          name = 'Product_category';
          break;
        case 'Product class':
          name = 'Product_class';
          break;
        case 'Product name':
          name = 'Product_name';
          break;
        case 'Related records':
          name = 'Related_records';
          break;
        case 'Requester':
          name = 'Requester';
          break;
        case 'Standards':
          name = 'Standards';
          break;
        case 'Status':
          name = 'Status';
          break;
        case 'Test Report Attachments':
          name = 'Test_Report_Attachments';
          break;
        case 'Trade Representative':
          name = 'Trade_Representative';
          break;
        case 'Maintenance date':
          name = 'maintenance_date';
          break;
        case 'Next maintenance date':
          name = 'next_maintenance_date';
          break;
        default:
          name = '';
          break;
      }
      return name;
    },
    translate(name) {
      if (this.$i18n.locale === 'Portuguese') {
        const res = this.convertToStrings(name);
        const data = {
          Accredited_by: 'Credenciado por',
          Approval_date: 'Data de Aprovação',
          next_maintenance_date: 'Próxima data de Manutenção',
          maintenance_date: 'Data de Manutenção',
          Archive_reason: 'Razão de Arquivamento',
          Barcode_Attachments: 'Anexos de Código de Barras',
          Brand_name: 'Nome da Marca',
          Certification_URL: 'URL da Certificação',
          Certification_mark: 'Marca da Certificação',
          Certification_number: 'Número da Certificação',
          Comments: 'Comentários',
          Country_of_origin: 'País de Origem',
          Description: 'Descrição',
          Expiration: 'Expiração',
          Imported_Product: 'Produto importado',
          Importer: 'Importador',
          Input_Status: 'Status de Entrada',
          Managed_by: 'Gerenciado Por',
          Manufacturer: 'Fabricante',
          Marked_input_voltage: 'Tensão de Entrada Marcada',
          Marked_input_wattage: 'Potência de Entrada Marcada',
          Model_name: 'Nome do Modelo',
          Ordinance: 'Portaria',
          Barcode: 'Código de barras',
          Product_Certificate_Attachments: 'Anexos de Certificado de Produto',
          Product_category: 'Categoria do Produto',
          Product_class: 'Classe do Produto',
          Product_name: 'Nome do Produto',
          Related_records: 'Registros Relacionados',
          Requester: 'Solicitante',
          Standards: 'Normas',
          Status: 'Status',
          Test_Report_Attachments: 'Anexos do Relatório de Testes',
          Trade_Representative: 'Representante Comercial'
        };
        return data[res];
      }
      return name;
    }
  }
};
</script>

<style scoped>
.hide-field {
  display: none;
}

.pl-8 {
  padding-left: 8px;
}

.pl-32 {
  padding-left: 32px;
}
.filter-wrapper {
  position: absolute;
  right: 0;
  padding: 14px;
  top: 114px;
  background: #ffffff;
  border: 1px solid #b3b3b3;
  z-index: 1;
  width: 320px;
}

.filter-options {
  min-height: 75vh;
  padding-bottom: 40px;
}

.p-relative {
  position: relative;
}

.filter-name {
  line-height: 19px;
  color: #4d4d4d;
  padding-left: 4px;
}

.list-options {
  margin-top: 14px;
}

.transform-img {
  transform: rotate(180deg);
}

ul {
  list-style: none;
  padding-left: 0px;
}

.emergo-filter-search-container {
  margin-left: 26px;
  width: 200px;
  position: relative;
}

.emergo-filter-search-icon {
  position: absolute;
  right: 0px;
}

.emergo-filter-search {
  background: #ffffff;
  border: 1px solid #4d4d4d;
  color: #4d4d4d;
  border-radius: 3px;
  height: 34px;
  width: 100%;
  padding: 6px 50px 6px 10px;
}

.emergo-filter-search::placeholder {
  color: #999;
}

.footer-section {
  position: absolute;
  bottom: 0px;
}
</style>
